function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const React = require('react');

function SvgExperienceSubCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("rect", {
    y: 0.225,
    width: 18,
    height: 17.55,
    rx: 3.188,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": 256,
    d: "M13.996 13.421h-2.138a.468.468 0 0 1-.438-.282L9.099 7.712a.102.102 0 0 0-.196-.003l-1.447 3.446a.123.123 0 0 0 .113.17h1.59a.245.245 0 0 1 .226.15l.696 1.549a.286.286 0 0 1-.263.397H4.03a.264.264 0 0 1-.241-.368l3.682-8.767a.498.498 0 0 1 .467-.311h2.124a.497.497 0 0 1 .467.31l3.707 8.768a.264.264 0 0 1-.24.368z",
    fill: "#fa0f00"
  }));
}

module.exports = React.memo(SvgExperienceSubCloud);